import { render } from "./Detail.vue?vue&type=template&id=d1fbfa80&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./detail.scss?vue&type=style&index=0&id=d1fbfa80&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fbfa80"]])

export default __exports__